module.exports = __webpack_public_path__ + "img/ccf-fr-FR.fe9c0ab2.png";